import * as yup from "yup";
import { PROFILE_TYPE_CONSULTANT } from "utils/constants";

export const createKeyPersonnelValidation = (profileType: number) =>
	yup.object({
		first_name: yup.string().required("First name is required"),
		last_name: yup.string().required("Last name is required"),
		email: yup
			.string()
			.email("Invalid email")
			.required("Email is required"),
		position: yup.string().required("Position is required"),
		experience: yup
			.number()
			.required("Experience is required")
			.min(1, "At least one year of experience is required")
			.max(100, "Experience cannot exceed 100 years"),
		sector_ids: yup
			.array()
			.of(yup.number())
			.min(1, "Select at least one sector"),
		disciplines:
			profileType === PROFILE_TYPE_CONSULTANT
				? yup
						.array()
						.of(
							yup.object().shape({
								expertise: yup
									.string()
									.required("Expertise is required"),
								disciplines: yup
									.array()
									.min(
										1,
										"Select at least one discipline"
									),
							})
						)
				: yup.array(),
	});
